
import { defineComponent, computed } from "vue";
import store from "@/store";
import TheLoading from "@/components/common/TheLoading.vue";
import TheLoadingMessage from "./components/common/TheLoadingMessage.vue";

export default defineComponent({
  components: {
    TheLoading, 
    TheLoadingMessage
  },
  setup() {
    // ローディング状態
    const isLoading = computed(() => store.getters["common/isLoading"]);

    // ローディング中のメッセージ
    const isLoadingMessage = computed(() => {
      const result = store.getters["common/getFullscreenLoadingState"]
      console.log("App.vue result = " + result);
      return store.getters["common/getFullscreenLoadingState"];
    });

    // 以下は、非同期処理のため、削除
    // Nativeにアクセストークン、APIキー等のAPI呼び出しに必要なパラメータの取得要求
    //store.dispatch("common/getApiBaseParams");

    return {
      isLoading,
      isLoadingMessage
    };
  }
});
